import Divider from '@UI/divider/Divider';
import ModalErrorBoundary from '@UI/errorBoundaries/ModalErrorBoundary';
import { HoveredPopover } from '@UI/index';
import TermModal from '@UI/termModal/TermModal';
import DemarcatonIcon from '@assets/img/icon_demarcation_high.svg';
import settings from '@config/settings';
import { getCompilerOptions } from '@utils/compilerOptionsHelper';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import {
  KovContentBlock,
  KovContentBlockProvider,
} from '@kathondvla/react-shared-components/src/components/contentBlock';
import { useRef } from 'react';

import './goalDemarcation.scss';

const GoalDemarcation = ({ demarcation, className, mandatory }) => {
  const termModalRef = useRef();

  const compilerOptions = getCompilerOptions({
    terms: demarcation.items.flatMap((z) => z.terms).filter((z) => z),
    markExplanations: demarcation.items.flatMap((z) => z.markExplanations).filter((z) => z),
    termModalRef,
  });

  return (
    <div className={`goal-demarcation ${className}`}>
      <div className="demarcation-left">
        <HoveredPopover content="Afbakening">
          <img className="icon-demarcation" src={DemarcatonIcon} />
        </HoveredPopover>
        <Divider mandatory={mandatory} />
      </div>
      <div className="demarcation-content">
        <KovContentBlockProvider
          baseUrl={settings.apisAndUrls.api}
          compilerOptions={compilerOptions}
        >
          <KovContentBlock key={demarcation.key} item={demarcation} showCollapsed={false} />
        </KovContentBlockProvider>
      </div>
      <Modal
        ref={termModalRef}
        size="sm"
        component={<TermModal />}
        errorBoundaryComponent={ModalErrorBoundary}
      />
    </div>
  );
};

export default GoalDemarcation;
